import { Button, Popconfirm } from "antd";
import { EyeInvisibleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import { useDeleteAccount } from "data/use-accounts";
import { getLastCrumb } from "../../../stores/crumbs";
import { withFlag } from "../../../components/with-flag";

export const DeleteAccount = withFlag("delete-entities")((props) => {
  const { account } = props;

  const navigate = useNavigate();
  const deleteAccount = useDeleteAccount({
    onSuccess: async (data, { mutation }) => {
      navigate(getLastCrumb() || "/accounts");
      // TODO: wrapping this in setTimeout for now to guarantee that
      // navigate has finished, and react has finished rendering.
      // Only then do we invalidate the cache.
      // A better UX would be to navigate the user to a loading screen, without
      // any calls to data that is getting removed. There, we can safely update the cache
      // without any janky experience.
      setTimeout(() => {
        mutation.onSuccess.call();
      });
    },
  });

  return (
    <Popconfirm
      cancelText="Cancel"
      okText="Yes"
      onConfirm={() => deleteAccount.mutateAsync({ id: account._id })}
      title={
        <div className="max-w-[300px]">
          Are you sure?
          <br />
          <br />
          All associated entities including followups, activities, and
          opportunities will be deleted.
          <br />
          <br />
        </div>
      }
    >
      <Button
        icon={<EyeInvisibleOutlined />}
        disabled={deleteAccount.isLoading}
      >
        Delete
      </Button>
    </Popconfirm>
  );
});
